import { render, staticRenderFns } from "./PackageExpire.vue?vue&type=template&id=faf93dd2&scoped=true"
import script from "./PackageExpire.vue?vue&type=script&lang=js"
export * from "./PackageExpire.vue?vue&type=script&lang=js"
import style0 from "./PackageExpire.vue?vue&type=style&index=0&id=faf93dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf93dd2",
  null
  
)

export default component.exports